import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDateTime'
})
export class ToDateTimePipe implements PipeTransform {

  transform(datetime: string): any {
    if (datetime == null) {
      return null;
    }

    const index = datetime.indexOf(' ');
    if (index > -1) {
      return datetime.substr(0, index) + 'T' + datetime.substr(index + 1);
    }
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/pipes/to-date-time.pipe.ts